import Component from '@glimmer/component';
import { service } from '@ember/service';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type NetworkStatus from '../services/network-status';
import type OfflineQueue from '../services/offline-queue';
import Icon from './icon';
import CloudOffIcon from '~icons/lucide/cloud-off';
import LoaderIcon from '~icons/lucide/loader-2';
import RefreshCwIcon from '~icons/lucide/refresh-cw';
import Trash2Icon from '~icons/lucide/trash-2';

export default class SyncStatusCard extends Component {
  @service declare networkStatus: NetworkStatus;
  @service declare offlineQueue: OfflineQueue;

  @action
  async syncNow(): Promise<void> {
    await this.offlineQueue.processQueue();
  }

  @action
  async clearQueue(): Promise<void> {
    await this.offlineQueue.clearQueue();
  }

  <template>
    {{#if this.offlineQueue.pendingCount}}
      <div class="alert alert-info mb-6 shadow" data-test-sync-status>
        {{#if this.offlineQueue.isSyncing}}
          <Icon @icon={{LoaderIcon}} class="h-5 w-5 shrink-0 animate-spin" />
          <span>Syncing offline submissions…</span>
        {{else}}
          <Icon @icon={{CloudOffIcon}} class="h-5 w-5 shrink-0" />
          <span>
            {{this.offlineQueue.pendingCount}}
            item{{if (isPlural this.offlineQueue.pendingCount) "s" ""}}
            waiting to sync
          </span>
          <div class="flex gap-2">
            {{#if this.networkStatus.isOnline}}
              <button
                type="button"
                class="btn btn-sm btn-primary gap-1"
                {{on "click" this.syncNow}}
              >
                <Icon @icon={{RefreshCwIcon}} class="h-3.5 w-3.5" />
                Sync now
              </button>
            {{/if}}
            <button
              type="button"
              class="btn btn-sm btn-ghost gap-1"
              title="Clear offline queue"
              {{on "click" this.clearQueue}}
            >
              <Icon @icon={{Trash2Icon}} class="h-3.5 w-3.5" />
            </button>
          </div>
        {{/if}}
      </div>
    {{/if}}
  </template>
}

function isPlural(count: number): boolean {
  return count !== 1;
}
